// extracted by mini-css-extract-plugin
module.exports = {"blogPost":"blog_blogPost__SUk6F"};